import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { PageLoader } from "@/components/shared";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";

import { AppSidebar } from "./app-sidebar";
import { AuthGuard } from "./auth-guard";
import { Header } from "./header";

/**
 * Admin qobig'i: sidebar + sarlavha + kontent.
 *
 * `AuthGuard` eng tashqarida: sessiya tekshirilmaguncha sidebar ham,
 * sarlavha ham chizilmaydi — aks holda kirmagan odam bir lahza to'liq
 * interfeysni ko'radi va bu chalkashtiradi.
 */
export default function AdminLayout() {
  return (
    <AuthGuard>
      {/* Qobiq aynan ekran bo'yi: aylantirish kontent maydonining o'zida
          bo'ladi. Busiz ro'yxat sahifasi "to'liq balandlik" degan
          narsaga ega bo'lmaydi — sahifa kontent bilan birga cho'ziladi
          va jadval sarlavhasi tepaga yopishmaydi. */}
      <SidebarProvider
        className="h-svh overflow-hidden"
        style={{ "--sidebar-width": "16rem" } as React.CSSProperties}
      >
        <AppSidebar />
        <SidebarInset className="min-h-0 overflow-hidden">
          <Header />
          <main className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-6">
            {/* Sahifa chunklari `lazy` — bu chegara sidebar va sarlavhani
                joyida qoldirib, faqat kontent maydonini yuklaydi. */}
            <Suspense fallback={<PageLoader className="min-h-[50vh]" />}>
              <Outlet />
            </Suspense>
          </main>
        </SidebarInset>
      </SidebarProvider>
    </AuthGuard>
  );
}
